export const ROUTE = {
  HOMEPAGE: '/'
}

export const ROUTE_NAMES_WITH_PAGINATION = []

export const ROUTE_NAME = {
  HOMEPAGE: 'index'
}
